// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.txt-width {
   width: 70% !important;
}
mat-select{
   width: 40% !important;
}

.main-body {
   overflow-y: auto;
   height: 160px;
}

.btn-edit {
   width: 25% !important;
   padding: 0 10px;
   text-align: right;
}

.btn-submit {
   text-align: right;
   padding-top:20px;
}

.name {
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   font-size: 14px;
   color: #555555;
}

.desc {
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   color: #999999;
   font-size: 13px;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/admin/add-group-company/add-group-company.component.css"],"names":[],"mappings":"AAAA;GACG,qBAAqB;AACxB;AACA;GACG,qBAAqB;AACxB;;AAEA;GACG,gBAAgB;GAChB,aAAa;AAChB;;AAEA;GACG,qBAAqB;GACrB,eAAe;GACf,iBAAiB;AACpB;;AAEA;GACG,iBAAiB;GACjB,gBAAgB;AACnB;;AAEA;GACG,gBAAgB;GAChB,uBAAuB;GACvB,mBAAmB;GACnB,eAAe;GACf,cAAc;AACjB;;AAEA;GACG,gBAAgB;GAChB,uBAAuB;GACvB,mBAAmB;GACnB,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,wBAAwB;AAC3B","sourcesContent":[".txt-width {\n   width: 70% !important;\n}\nmat-select{\n   width: 40% !important;\n}\n\n.main-body {\n   overflow-y: auto;\n   height: 160px;\n}\n\n.btn-edit {\n   width: 25% !important;\n   padding: 0 10px;\n   text-align: right;\n}\n\n.btn-submit {\n   text-align: right;\n   padding-top:20px;\n}\n\n.name {\n   overflow: hidden;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n   font-size: 14px;\n   color: #555555;\n}\n\n.desc {\n   overflow: hidden;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n   color: #999999;\n   font-size: 13px;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
